// Provider logos v7 — simpel eigen logo, hollandsnieuwe/simyo keys, online.nl voor delta
window.PV_LOGO_CLEARBIT={
  odido:'odido.nl',vodafone:'vodafone.nl',ben:'ben.nl',simyo:'simyo.nl',
  kpn:'kpn.com',ziggo:'ziggo.nl',youfone:'youfone.nl',lebara:'lebara.com',
  delta:'delta.nl',onlinenl:'online.nl',hollandsnieuwe:'hollandsnieuwe.nl',
  simpel:'simpel.nl'
};
window.PV_LOGO_SVGCDN={
  odido:'https://dl.svgcdn.com/png/cbi/odido-200.png',
  vodafone:'https://dl.svgcdn.com/png/cbi/vodafone-200.png',
  ben:'https://dl.svgcdn.com/png/cbi/ben-200.png',
  simyo:'https://dl.svgcdn.com/png/cbi/simyo-200.png',
  kpn:'https://dl.svgcdn.com/png/cbi/kpn-200.png',
  ziggo:'https://dl.svgcdn.com/png/cbi/ziggo-200.png',
  youfone:'https://dl.svgcdn.com/png/cbi/youfone-200.png',
  lebara:'https://dl.svgcdn.com/png/cbi/lebara-200.png',
  delta:'https://dl.svgcdn.com/png/cbi/delta-200.png'
};
window.PV_COLORS={odido:'#6b2d8b',vodafone:'#e60000',ben:'#0066cc',simyo:'#00b67a',kpn:'#00a550',ziggo:'#ff6200',youfone:'#e6007e',lebara:'#e4003a',delta:'#0072bc',onlinenl:'#ff7900',hollandsnieuwe:'#ff6600',simpel:'#e2001a'};
window.PV_DISPLAY={odido:'Odido',vodafone:'Vodafone',ben:'Ben',simyo:'Simyo',kpn:'KPN',ziggo:'Ziggo Meervoordeel',youfone:'Youfone',lebara:'Lebara',delta:'DELTA',onlinenl:'Online.nl',hollandsnieuwe:'hollandsnieuwe',simpel:'Simpel'};
window.pvProvKey=function(n){
  var m=(n||'').toLowerCase();
  // VOLGORDE belangrijk: specifiekere losse merken EERST
  if(m.includes('hollandsnieuwe')||m.includes('hollands nieuwe'))return'hollandsnieuwe';
  if(m.includes('simyo'))return'simyo';
  if(/\bsimpel\b/.test(m))return'simpel';
  if(m.includes('online.nl')||m.includes('online nl'))return'onlinenl';
  if(m.includes('odido')||m.includes('t-mobile'))return'odido';
  if(m.includes('vodafone'))return'vodafone';
  if(/\bben\b/.test(m))return'ben';
  if(m.includes('kpn'))return'kpn';
  if(m.includes('ziggo'))return'ziggo';
  if(m.includes('youfone'))return'youfone';
  if(m.includes('lebara'))return'lebara';
  if(m.includes('delta'))return'delta';
  return '';
};
window.pvProvName=function(merchantName){
  var k=pvProvKey(merchantName);
  if(k&&PV_DISPLAY[k])return PV_DISPLAY[k];
  return (merchantName||'')
    .replace(/T-Mobile NL/gi,'Odido').replace(/T-Mobile/gi,'Odido')
    .replace(/Mobiel NL/gi,'').replace(/Thuis NL/gi,'').replace(/ NL\b/gi,'')
    .replace(/Zakelijk/gi,'').replace(/\s+/g,' ').trim();
};
window.pvLogoBox=function(merchantName,size){
  size=size||56;
  var k=pvProvKey(merchantName);
  var fixed=pvProvName(merchantName)||merchantName||'';
  var domain=PV_LOGO_CLEARBIT[k];
  var svgUrl=PV_LOGO_SVGCDN[k];
  var color=PV_COLORS[k]||'#1B3FA0';
  var label=fixed.length<=8?fixed:(fixed.split(' ')[0]||'').substring(0,6);
  var fbSvg='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">'
    +'<rect width="100" height="100" fill="'+color+'" rx="16"/>'
    +'<text x="50" y="62" font-family="Arial Black,Arial,sans-serif" '
    +'font-size="'+(label.length<=3?32:label.length<=5?24:label.length<=7?18:14)+'" '
    +'font-weight="900" fill="white" text-anchor="middle">'+label.toUpperCase()+'</text></svg>';
  var fbUri='data:image/svg+xml;base64,'+btoa(unescape(encodeURIComponent(fbSvg)));
  var sty='width:'+size+'px;height:'+size+'px;object-fit:contain;border-radius:10px;'
    +'border:1.5px solid #e8edf5;background:#fff;padding:2px;flex-shrink:0;display:block;';
  if(domain){
    var svgFallback=svgUrl
      ?'this.src=\''+svgUrl+'\';this.onerror=function(){this.src=\''+fbUri+'\';this.onerror=null;};'
      :'this.src=\''+fbUri+'\';this.onerror=null;';
    return'<img src="https://logo.clearbit.com/'+domain+'?size=256" alt="'+fixed+'" width="'+size+'" height="'+size+'" style="'+sty+'" loading="eager" onerror="'+svgFallback+'">';
  }
  if(svgUrl){
    return'<img src="'+svgUrl+'" alt="'+fixed+'" width="'+size+'" height="'+size+'" style="'+sty+'" loading="eager" onerror="this.src=\''+fbUri+'\';this.onerror=null;">';
  }
  return'<img src="'+fbUri+'" alt="'+fixed+'" width="'+size+'" height="'+size+'" style="'+sty+'">';
};
